var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1934_14510",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 4,
    width: 21,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3125 5.5H24.75C25.5063 5.5 26.125 6.11875 26.125 6.875C26.125 7.63125 25.5063 8.25 24.75 8.25H8.25C7.49375 8.25 6.875 7.63125 6.875 6.875C6.875 6.11875 7.49375 5.5 8.25 5.5H11.6875L12.6638 4.52375C12.9113 4.27625 13.2688 4.125 13.6263 4.125H19.3738C19.7313 4.125 20.0888 4.27625 20.3363 4.52375L21.3125 5.5ZM11.0003 28.8751C9.48777 28.8751 8.25027 27.6376 8.25027 26.1251V12.3751C8.25027 10.8626 9.48777 9.62507 11.0003 9.62507H22.0003C23.5128 9.62507 24.7503 10.8626 24.7503 12.3751V26.1251C24.7503 27.6376 23.5128 28.8751 22.0003 28.8751H11.0003Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1934_14510)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "#858C94"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.1087ff88ac0915f0de0263a67fe9844d.svg";
export { ForwardRef as ReactComponent };